export const euCountries = [
  'cz',
  'lu',
  'ro',
  'dk',
  'it',
  'es',
  'de',
  'se',
  'hu',
  'pl',
  'be',
  'at',
  'fi',
  'cy',
  'pt',
  'bg',
  'fr',
  'lt',
  'mt',
  'nl',
  'ee',
  'ie',
  'gr',
  'lv',
  'hr',
  'si',
  'sk',
];
